export default __webpack_public_path__ + "static/media/select-radius.44219be2.png";